<template>
  <b-row>
    <b-col cols="12" class="d-flex justify-content-end">
      <b-button v-if="HasPermission(PermissionList.Sales_Create)" variant="primary" :to="{ name: 'quotation-add' }" :disabled="loading">
        Add Quotation
      </b-button>
    </b-col>
    <b-col cols="12" md="2" sm="2" class="my-1">
      <b-form-group class="mb-0">
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" />
      </b-form-group>
    </b-col>
    <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
      <b-button v-if="HasPermission(PermissionList.Sales_Search)" variant="outline-danger"@click="clearFilters" :disabled="!anyFilterActive">
        Clear Filters
      </b-button>
    </b-col>

    <b-col cols="12">
      <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="filteredQuotations"
        :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
        @filtered="onFiltered">

        <!-- Quotation No Filter -->
        <template #head(quotationNo)>
          <div class="d-flex flex-column">
            <span>Quotation No</span>
            <b-form-input v-model="columnFilters.quotationNo" placeholder="Filter by Quotation No" size="sm"
              @input="filterTable" />
          </div>
        </template>

        <!-- Customer Filter -->
        <template #head(leadClientName)>
          <div class="d-flex flex-column">
            <span>Customer</span>
            <b-form-input v-model="columnFilters.customer" placeholder="Filter by Customer" size="sm"
              @input="filterTable" />
          </div>
        </template>

        <!-- Customer Email Filter -->
        <template #head(leadClientEmail)>
          <div class="d-flex flex-column">
            <span>Customer Email</span>
            <b-form-input v-model="columnFilters.customerEmail" placeholder="Filter by Customer Email" size="sm"
              @input="filterTable" />
          </div>
        </template>

        <!-- Sales Person Filter -->
        <template #head(salesPersonId)>
          <div class="d-flex flex-column">
            <span>Sales Person</span>
            <b-form-input v-model="columnFilters.salesPerson" placeholder="Filter by Sales Person" size="sm"
              @input="filterTable" />
          </div>
        </template>

        <template #head(priority)>
          <div class="d-flex flex-column">
            <span>Priority</span>
            <b-form-input v-model="columnFilters.priority" placeholder="Filter by priority" size="sm"
              @input="filterTable" />
          </div>
        </template>

        <!-- Due Date Filter -->
        <template #head(dueDate)>
          <div class="d-flex flex-column">
            <span>Due Date</span>
            <date-picker v-model="columnFilters.dueDate" :range="true" format="YYYY-MM-DD"
              placeholder="Select Date Range" @change="filterTable" :clearable="false" :input-attr="{ readonly: true }"
              @focus="openCalendar" class="small-datepicker" />
          </div>
        </template>

        <!-- Created On Filter -->
        <template #head(createdOn)>
          <div class="d-flex flex-column">
            <span>Created On</span>
            <date-picker v-model="columnFilters.createdOn" :range="true" format="YYYY-MM-DD"
              placeholder="Select Date Range" @change="filterTable" :clearable="false" :input-attr="{ readonly: true }"
              @focus="openCalendar" class="small-datepicker" />
          </div>
        </template>

        <template #head(status)>
          <div class="d-flex flex-column">
              <span>STATUS</span>
              <b-form-select
                v-model="columnFilters.status"
                @change="filterTable"
                size="sm"
              >
                <option value="">All</option>
                <option value="NEW">NEW</option>
                <option value="PROFORMA">PROFORMA</option>
              </b-form-select>
            </div>
        </template>

        <!-- Table Cells -->
         <!-- Display status as Badge in Table -->
         <template #cell(status)="data">
            <b-badge v-if="data.item.status === 0" variant="secondary"
              >New</b-badge
            >
            <b-badge v-else-if="data.item.status === 3" variant="info"
              >Proforma</b-badge
            >
          </template>
        <template #cell(total)="data"> {{ (data.item.currency == null) ? "Rs" : getCurrencySymbol(data.item.currency) }}
          {{ data.item.total.toFixed(2) }} </template>
        <template v-slot:cell(dueDate)="data">
          {{ convertTimestampToDate(data.item.dueDate) }}
        </template>
        <template #cell(createdOn)="data">
          {{ convertTimestampToDate(data.item.createdOn) }}
        </template>
        <template #cell(salesPersonId)="data">
          {{ getSalePersonName(data.item.salesPersonId) }}
        </template>
        <template #cell(actions)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template v-slot:button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item v-if="HasPermission(PermissionList.Sales_View)" v-b-modal.modal-edit :to="getQuotationId(data.item.id)">
              <feather-icon icon="EyeIcon" class="mr-50" />
              <span>View</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="HasPermission(PermissionList.Sales_Update) && data.item.status != 3" v-b-modal.modal-edit :to="getQuotationEdit(data.item.id)">
              <feather-icon icon="Edit2Icon" class="mr-50" />
              <span>Edit</span>
            </b-dropdown-item>
            <b-dropdown-item v-if="HasPermission(PermissionList.Sales_Delete)" @click="removequotation(data.item.id)">
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Delete</span>
            </b-dropdown-item>
          </b-dropdown>
          
        </template>
      </b-table>
      <div class="d-flex justify-content-center mb-1">
        <b-alert variant="warning" show v-if="quotationList.length === 0" class="d-flex justify-content-center">
          <h4 class="alert-heading">No Quotations yet</h4>
        </b-alert>
      </div>
      <div class="d-flex justify-content-center mb-1">
        <b-spinner variant="success" label="Spinning" block v-if="loading"
          style="width: 3rem; height: 3rem"></b-spinner>
      </div>
    </b-col>

    <b-col cols="12">
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
        class="my-0" />
      <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapActions, mapGetters } from "vuex";
import { CurrencySymbols } from '@/libs/defaultList';

import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BAlert,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BSpinner,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { PermissionList } from '@/libs/defaultList';
import { HasPermission } from '@/@core/utils/validations/permissionCheck';

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BAlert,
    BDropdown,
    BDropdownItem,
    DatePicker,
  },
  data() {
    return {
      perPage: 5,
      quotationData: [],
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 0,
      sortBy: "",
      sortDesc: false,
      status: "",
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      columnFilters: {
        quotationNo: "",
        customer: "",
        customerEmail: "",
        salesPerson: "",
        priority: "",
        status: "",
        dueDate: null,
        createdOn: null,
      },
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        { key: "quotationNo", label: "Quotation No", sortable: true },
        { key: "leadClientName", label: "Customer", sortable: true },
        { key: "leadClientEmail", label: "Customer Email", sortable: true },
        { key: "priority", label: "Priority", sortable: true },
        { key: "total", label: "Total" },
        { key: "salesPersonId", label: "Sales Person", sortable: true },
        { key: "dueDate", label: "Due Date", sortable: true },
        { key: "createdOn", label: "Created On", sortable: true },
        { key: "status", label: "Status", sortable: true },
        "actions",
      ],
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    ...mapGetters("quotationModule", {
      quotationList: "quotations",
      loading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    filteredQuotations() {
      return this.quotationList.filter((item) => {
        const matchesQuotationNo = !this.columnFilters.quotationNo ||
          String(item.quotationNo).toLowerCase().includes(this.columnFilters.quotationNo.toLowerCase());
        const matchesCustomer = !this.columnFilters.customer ||
          String(item.leadClientName || "").toLowerCase().includes(this.columnFilters.customer.toLowerCase());
        const matchesCustomerEmail = !this.columnFilters.customerEmail ||
          String(item.leadClientEmail || "").toLowerCase().includes(this.columnFilters.customerEmail.toLowerCase());
        const matchesSalesPerson = !this.columnFilters.salesPerson ||
          this.getSalePersonName(item.salesPersonId).toLowerCase().includes(this.columnFilters.salesPerson.toLowerCase());
        const matchesPriority = !this.columnFilters.priority ||
          String(item.priority || "").toLowerCase().includes(this.columnFilters.priority.toLowerCase());
        const matchesDueDate = !this.columnFilters.dueDate ||
          this.isWithinRange(item.dueDate, this.columnFilters.dueDate);
        const matchesCreatedOn = !this.columnFilters.createdOn ||
          this.isWithinRange(item.createdOn, this.columnFilters.createdOn);
        const matchesStatus = !this.columnFilters.status || 
          this.getStatusText(item.status) === this.columnFilters.status;

        return matchesQuotationNo && matchesCustomer && matchesCustomerEmail && matchesSalesPerson &&matchesPriority && matchesDueDate && matchesCreatedOn && matchesStatus;
      });
    },
    anyFilterActive() {
      const { quotationNo, customer, customerEmail, salesPerson, dueDate, createdOn, status } = this.columnFilters;
      return (
        quotationNo || customer || customerEmail || salesPerson || dueDate || createdOn || status
      );
    },
  },

  methods: {
    getSalePersonName(id) {
      const salesPerson = this.SalesPersonList.find((s) => s.id === id);
      return salesPerson ? salesPerson.firstName + " " + salesPerson.lastName : "";
    },
    getquotationData(data) {
      this.quotationData = data;
    },
    convertTimestampToDate(timestamp) {
      return new Date(timestamp).toLocaleDateString();
    },
    getCurrencySymbol(currency) {
      return CurrencySymbols[currency];
    },
    removequotation(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removeQuotationsAction(id);
          this.$swal({
            icon: "success",
            title: "Deleted!",
            text: "Your file has been deleted.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Your file is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    ...mapActions("quotationModule", [
      "getQuotationsListAction",
      "removeQuotationsAction",
    ]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    getQuotationId(item) {
      return "/quotation/preview/" + item;
    },

    getQuotationEdit(item) {
      return "/quotation/edit/" + item;
    },
    filterTable() {
      this.currentPage = 1;
      this.totalRows = this.filteredQuotations.length;
    },
    
    isWithinRange(date, range) {
      if (!date || !range || range.length !== 2) return false;
      const [start, end] = range.map((d) => new Date(d));
      const itemDate = new Date(date);
      return itemDate >= start && itemDate <= end;
    },
    openCalendar(event) {
      // Ensure the calendar opens on focus
      event.target.blur(); // Remove focus to prevent further typing
      event.target.click(); // Programmatically open the calendar

      // Add an event listener to detect clicks outside the date picker
      document.addEventListener('click', this.closeCalendar);
    },
    closeCalendar(event) {
      const datePicker = this.$refs.datePicker.$el;

      // Check if the click happened outside the date picker
      if (!datePicker.contains(event.target)) {
        // Close the calendar by clicking outside
        this.$refs.datePicker.hideCalendar();

        // Remove the event listener after closing
        document.removeEventListener('click', this.closeCalendar);
      }
    },
    getStatusText(status) {
      switch (status) {
        case 0:
          return "NEW";
        case 3:
          return "PROFORMA";
      }
    },
    clearFilters() {
      // Reset columnFilters to clear all filters
      this.columnFilters = {
        quotationNo: "",
        customer: "",
        customerEmail: "",
        salesPerson: "",
        priority: "",
        dueDate: null,
        createdOn: null,
        status: "",
      };
      // Reapply filters and reset pagination
      this.filterTable();
    },
  },
  async mounted() {
    await this.getSalesPersonListAction();
    await this.getQuotationsListAction();
    this.totalRows = this.quotationList.length;
  },
  setup(props){
    return{
      PermissionList,
      HasPermission
    }
  }
};
</script>

<style scoped>
.small-datepicker {
  width: 150px;
  /* Adjust width as desired */
}
</style>